<template>
  <transition name="modal" v-if="editCategories">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="cancel">
        <div class="modal-container">
          <div class="modal-header">
            <h3>Categories</h3>
          </div>
          <div class="modal-body form-horizontal">
            <div v-if="currentCategoryIndex === null">
              <div
                v-for="(category, index) in categories" :key="index"
                @click="currentCategoryIndex = index"
                class="blue-outline pointer">
                {{ category.category }}
              </div>
            </div>
            <div v-else>
              <h4>{{ currentCategory.category }}</h4>
              <div class="clearfix"></div>
              <form-image-uploader
                v-model="currentCategory.image"
                :albumName="'categoryImages'"
                :inputLabel="'Image'"
                v-on:uploaded="saveWithoutReset"
                v-on:removed="saveWithoutReset"
                ></form-image-uploader>
            </div>
          </div>
          <div class="modal-footer">
            <div v-if="currentCategoryIndex === null">
              <button class="btn btn-default" @click="cancel">Cancel</button>
              <!-- <button class="btn admin-btn-primary" @click="save">Save</button> -->
            </div>
            <div v-else>
              <button class="btn btn-default" @click="back">Back</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import FormImageUploader from '../../FormImageUploader'

export default {
  name: 'CategoriesModal',
  props: ['editCategories', 'program'],
  components: {
    'form-image-uploader': FormImageUploader
  },
  data () {
    return {
      // rebateItemOriginalData: {},
      notification: '',
      currentCategoryIndex: null
    }
  },
  computed: {
    categories () {
      return this.program.categories
    },
    currentCategory: {
      get () {
        return this.program.categories[this.currentCategoryIndex]
      },
      set (value) {
        this.program.categories[this.currentCategoryIndex] = value
      }
    }
  },
  methods: {
    ...mapMutations('loyaltyProgram', {
      setProgram: 'SET_PROGRAM',
      updateProgram: 'UPDATE_PROGRAM'
    }),
    ...mapActions('loyaltyProgram', [ 'saveProgram' ]),
    save () {
      this.setProgram(this.program)
      this.saveProgram()
        .then(response => {
          this.$emit('close')
        })
        .catch(err => {
          console.log(err)
        })
    },
    saveWithoutReset () {
      this.setProgram(this.program)
      this.saveProgram()
        .then(response => {
          // console.log(response)
        })
        .catch(err => {
          console.log(err)
        })
    },
    cancel () {
      this.reset()
      this.$emit('close')
    },
    back () {
      this.reset()
      this.currentCategoryIndex = null
    },
    reset () {
      Object.assign(this.$data, this.$options.data())
    },
    notify (message) {
      this.notification = message
      setTimeout(() => {
        this.notification = ''
      }, 3000)
    }
  }
}
</script>

<style scoped>
.modal-body {
  max-height: 60vh;
  overflow-y: auto;
}

.modal-enter-active, .modal-leave-active {
  transition: opacity .6s;
}
.modal-enter, .modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
